module.exports = __webpack_public_path__ + "static/media/cc-dev-overview.6e4382bb.png";